"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var Loading_styled_1 = require("./Loading.styled");
var ContractsColumn = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, SkeletonHeading = _a.SkeletonHeading, SkeletonText = _a.SkeletonText;
    var array = [];
    for (var i = 0; i < 12; i++) {
        array.push(react_1.default.createElement(SkeletonText, { lines: 1, key: i }));
    }
    return (react_1.default.createElement(Loading_styled_1.LoadingColumn, { as: Card },
        react_1.default.createElement(SkeletonHeading, null),
        array));
};
var Loading = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, SkeletonHeading = _a.SkeletonHeading, SkeletonText = _a.SkeletonText;
    return (react_1.default.createElement("section", null,
        react_1.default.createElement(Loading_styled_1.FlexChild, { as: Card },
            react_1.default.createElement(SkeletonHeading, null),
            react_1.default.createElement(SkeletonText, { lines: 2 })),
        react_1.default.createElement(Loading_styled_1.ColumnContainer, null,
            react_1.default.createElement(ContractsColumn, null),
            react_1.default.createElement(ContractsColumn, null))));
};
exports.Loading = Loading;
